import React from "react";
import { useNavigate } from "react-router-dom";
import StudentSidebar from "../components/studentsidebar";
import Navbar from "../components/studentnavbar";
import { height } from "@fortawesome/free-solid-svg-icons/fa0";
import { useSidebar } from '../components/SidebarContext';

const CompletedTests = () => {const { isSidebarOpen } = useSidebar(); const sidebarWidth = isSidebarOpen ? '15.6rem' : '4.4rem';
  const navigate = useNavigate();

  const tests = [
    {
      _id: "1",
      testName: "Math Final Exam",
      overallPercentage: 85,
      grade: "A",
    },
    {
      _id: "2",
      testName: "Science Quiz",
      overallPercentage: 72,
      grade: "B",
    },
    {
      _id: "3",
      testName: "English Test",
      overallPercentage: 63,
      grade: "C",
    },
  ];

  // Inline styles
  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    marginLeft: "16rem", // sidebar offset
    padding: "2rem",
  };

  const pageStyle = {
    minHeight: "100vh",
    background: "linear-gradient(to right, #EFF6FF, #F3E8FF, #FEE7EF)",
    position: "relative"
  };

  const sidebarStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    height: "100%",
    width: "16rem",
    zIndex: 10
  };

  const cardStyle = {
    backgroundColor: "white",
    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    borderRadius: "1rem",
    width: "100%",
    height: "100%",
    padding: "2.5rem"
  };

  const titleStyle = {
    fontSize: "2.25rem", // text-4xl
    fontWeight: "bold",
    color: "#7E22CE", // purple-700
    marginBottom: "2rem",
    textAlign: "center"
  };

  const tableContainerStyle = {
    overflowX: "auto"
  };

  const tableStyle = {
    width: "100%",
    fontSize: "1.125rem", // text-lg
    border: "1px solid #D1D5DB" // border-gray-300
  };

  const thStyle = {
    border: "1px solid #D1D5DB",
    padding: "1rem",
    backgroundColor: "#F3E8FF", // purple-100
    color: "#6B21A8" // purple-800
  };
  
  const tdStyle = {
    border: "1px solid #D1D5DB",
    padding: "1rem"
  };

  const tdCenterStyle = {
    ...tdStyle,
    textAlign: "center"
  };

  const tdNameStyle = {
    ...tdStyle,
    fontWeight: "500",
    color: "#374151" // text-gray-700
  };

  const tdPercentStyle = {
    ...tdCenterStyle,
    fontWeight: "600",
    color: "#2563EB" // text-blue-600
  };
  
  const tdGradeStyle = {
    ...tdCenterStyle,
    fontWeight: "700",
    color: "#16A34A" // text-green-600
  };

  const buttonStyle = {
    backgroundColor: "#4169E1", // purple-800
    color: "white",
    padding: "0.5rem 1rem",
    border: "none",
    borderRadius: "0.375rem",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  };

  const emptyMessageStyle = {
    color: "#6B7280", // text-gray-500
    marginTop: "1.5rem",
    textAlign: "center",
    fontSize: "1.25rem" // text-xl
  };

  const handleViewResult = (testId) => {
    navigate(`/result/${testId}`);
  };

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f0f4f8", display: "flex" }}>
    {/* Sidebar */}
    <div style={{ position: "fixed", top: 0, left: 0, height: "100%", width: "250px", zIndex: 10 }}>
      <StudentSidebar />
    </div>

    {/* Navbar */}
    <Navbar />

      {/* Main content centered */}
      <div style={{ marginLeft: sidebarWidth, marginTop: "55px", width: `calc(100% - ${sidebarWidth}`,transition: 'all 0.3s ease'} }>
        <div style={cardStyle}>
          <h1 style={titleStyle}>
            🎯 Result Tests
          </h1>

          <div style={tableContainerStyle}>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>#</th>
                  <th style={thStyle}>Test Name</th>
                  <th style={thStyle}>Overall %</th>
                  <th style={thStyle}>Grade</th>
                  <th style={thStyle}>Action</th>
                </tr>
              </thead>
              <tbody>
                {tests.map((test, index) => (
                  <tr
                    key={test._id}
                    style={{
                      backgroundColor: index % 2 === 0 ? "white" : "#F9FAFB",
                      transition: "background-color 0.3s ease"
                    }}
                    onMouseOver={(e) => {e.currentTarget.style.backgroundColor = "#DCFCE7"}}
                    onMouseOut={(e) => {e.currentTarget.style.backgroundColor = index % 2 === 0 ? "white" : "#F9FAFB"}}
                  >
                    <td style={tdCenterStyle}>{index + 1}</td>
                    <td style={tdNameStyle}>
                      {test.testName}
                    </td>
                    <td style={tdPercentStyle}>
                      {test.overallPercentage}%
                    </td>
                    <td style={tdGradeStyle}>
                      {test.grade}
                    </td>
                    <td style={tdCenterStyle}>
                      <button
                        style={buttonStyle}
                        onClick={() => handleViewResult(test._id)}
                        onMouseOver={(e) =>
                          (e.target.style.backgroundColor = "#5B21B6") // darker on hover
                        }
                        onMouseOut={(e) =>
                          (e.target.style.backgroundColor = "#6B21A8") // original color
                        }
                      >
                        View Result
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {tests.length === 0 && (
              <p style={emptyMessageStyle}>
                No completed tests available.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompletedTests;